// extracted by mini-css-extract-plugin
module.exports = {"whole":"Users_whole__wnGA_","components":"Users_components__3_-Gj","search":"Users_search__1lXDq"};